import axios from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export interface IStatusOnEquipment {
  0: number;
  1: number;
  2: number;
}

export interface IDevice {
  brandID: number;
  codArm: number;
  dOrder: number;
  dType: number;
  devID: number;
  devType: number;
  eid: number;
  sn: string;
  status: number;
  productCode: string;
  statusOnEquipment: IStatusOnEquipment[];
}

export interface IDevicesResponse extends ApiResponse {
  devices: IDevice[];
}

export const fetchDevices = (
  controller: AbortController,
  devID?: number,
  eid?: number,
  sn?: string,
  codArm?: number,
  productCode?: string
): Promise<IDevicesResponse> => {
  const url =
    `${zps_ms_ea_war}/device?` +
    (eid ? `&eid=${eid}` : '') +
    (sn ? `&sn=${sn}` : '') +
    (codArm ? `&codArm=${codArm}` : '') +
    (devID ? `&devID=${devID}` : '') +
    (productCode ? `&productCode=${productCode}` : '');

  return axios.get<IDevicesResponse>(url, { signal: controller.signal }).then(res => res.data);
};
